enum CustomConfigs {
  DisableGTM = 'vdp-disable-gtm',
  EnableDebug = 'merch-enable-debug',
  DisableLazyLoad = 'vdp-disable-lazy-load',
  DisableSpinner = 'vdp-disable-spinner',
  enableNewCarConfiguratorV2 = 'enable-new-car-configurator-v2',
  enableSpurMonocle = 'enable-spur-monocle',
  enableTestDriveCenterDealershipHome = 'enable-test-drive-center-dealership-home',
  EnableMfeDebug = 'merch-enable-mfe-debug',
  enableUuidFeatureFiltering = 'enable-uuid-feature-filtering',
  enableWindowDealerCodeVar = 'enable-window-dealer-code-var',
  FeatureBranch = 'feature-branch',
  ForceServerError = 'force-server-error',
  MockVehicle = 'vdp-mock-vehicle',
  PriceDrop = 'show-price-drop-banner',
  RemoveFooter = 'merch-remove-footer',
  RemoveHeader = 'merch-remove-header',
  shouldUseTitleCasing = 'should-use-title-casing',
  showShaqvanaVideosSection = 'show-shaqvana-videos-section',
  useCatalogOEMData = 'use-catalog-oem-data',
  useCubeLegacyUrl = 'use-cube-legacy-url',
  useVaultWhyBuy = 'use-vault-why-buy',
  withModalOpen = 'wmo'
}

export default CustomConfigs;
